import React, { useState } from "react";
import CheckoutForm from "./CheckoutForm";

const Popup = ({ data, itemName }) => {
  const checkData = () => {
    if (data.itemName == itemName) {
      const itemName = document.getElementById("itemName");
      const itemImage = document.getElementById("itemImage");
      const itemDesc = document.getElementById("itemDesc");
      let newData = data;
      itemName.innerText = newData.itemName;
      itemImage.src = newData.itemImage;
      itemDesc.innerText = `Price: ₹${newData.itemPrice},  Category: ${newData.itemCategory}`;
    }
  };
  return (
    <div>
      <div
        class="modal fade"
        id="exampleModalToggle"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalToggleLabel">
                Your Order Details
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="card popupCard">
                <img
                  src={data.itemImage}
                  id="itemImage"
                  class="card-img-top"
                  alt="..."
                />
                <div class="card-body">
                  <h5 class="card-title" id="itemName">
                    Item Name: {data.itemName}
                  </h5>
                  <p class="card-text fw-bold" id="itemDesc">
                    Price: ₹{data.itemPrice}, Category: {data.itemCategory}
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-primary"
                data-bs-target="#exampleModalToggle2"
                data-bs-toggle="modal"
              >
                Order Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="exampleModalToggle2"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel2"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalToggleLabel2">
                Fill The Details to Place Order
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <CheckoutForm />
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-primary"
                data-bs-target="#exampleModalToggle"
                data-bs-toggle="modal"
              >
                Back to first
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        class="btn btn-dark py-1 px-3"
        data-bs-target="#exampleModalToggle"
        data-bs-toggle="modal"
        onClick={() => checkData()}
      >
        Place Order
      </button>
    </div>
  );
};

export default Popup;
